module.exports = __webpack_public_path__ + "static/assets/7337f194b0a727f4be98902487dfb615.mp3";